/**
 * Prevent user from opening multiple dropdown menus.
 * @returns {*|jQuery}
 */
export const enablePreventMultipleDropdownMenus = () => jQuery('#navbarSupportedContent .toggle-menu-menu').click(e => {
    const menuIsAlreadyCollapsing = jQuery('.collapsing').length;
    if (menuIsAlreadyCollapsing) {
        e.stopPropagation();
        return;
    }
    jQuery('.collapse.mega-menu').collapse('hide');
});

/**
 * Font switcher
 * @param selectors
 * @param clickedSelector
 * @param sizeToSet
 * @param textDecorationClass
 */
const fontSizeSwitchHandler = (selectors, clickedSelector, sizeToSet, textDecorationClass) => {
    const fontSizeCss = {
        property: 'font-size',
        small: '100%',
        medium: '120%',
        large: '140%',
    };
    const mainNavCss = {
        property: 'top',
        small: '2.8em',
        medium: '2.7em',
        large: '2.6em',
    };
    const searchNavCss = {
        property: 'top',
        small: '8.4em',
        medium: '7.4em',
        large: '6.6em',
    };

    jQuery(`${selectors.fontSizeSmall}, ${selectors.fontSizeMedium}, ${selectors.fontSizeLarge}`).removeClass(textDecorationClass);
    jQuery(selectors.body).css(fontSizeCss.property, fontSizeCss[sizeToSet]);
    jQuery(selectors.mainNav).css(mainNavCss.property, mainNavCss[sizeToSet]);
    jQuery(selectors.searchNav).css(searchNavCss.property, searchNavCss[sizeToSet]);
    jQuery(clickedSelector).addClass(textDecorationClass);
};

let currentFontSizeIndex = 1;
export const enableFontSizeSwitcher = () => {
    const selectors = {
        body: 'body',
        increaseFontSize: '#increase-font-size',
    };

    const fontSizeProperty = 'font-size';
    const fontSizes = ['100%', '120%', '140%'];
    const marginClasses = ['m-100', 'm-120', 'm-140'];

    jQuery(selectors.increaseFontSize).click(() => {
        const navbar = jQuery('.navbar');
        // Reset font size if it is already increased to the max.
        if (currentFontSizeIndex >= fontSizes.length) {
            jQuery(selectors.body).css(fontSizeProperty, fontSizes[0]);
            currentFontSizeIndex = 1;
            navbar.removeClass(marginClasses);
            navbar.addClass(marginClasses[0]);
            return;
        }
        jQuery(selectors.body).css(fontSizeProperty, fontSizes[currentFontSizeIndex]);
        navbar.removeClass(marginClasses);
        navbar.addClass(marginClasses[currentFontSizeIndex]);
        currentFontSizeIndex++;
    });
};

const handleDropdownClick = config => {
    if (!jQuery('.overflow-image').length) {
        return;
    }
    jQuery(config.clickableElementSelector).on('click', function (e) {
        setTimeout(() => {
            let ariaExpanded = false;
            $(config.expandableElementSelector).each(function () {
                if ($(this).attr('aria-expanded') === 'true') {
                    ariaExpanded = true;
                }
            });
            if (ariaExpanded) {
                $(config.updateElementSelector).removeClass(config.toggleClass);
            } else {
                $(config.updateElementSelector).addClass(config.toggleClass);
            }
        }, 0);
    });
};

export const enableNavStyleChangesOnDropdownClick = () => {
    const desktopConfig = {
        clickableElementSelector: '.navbar div.toggle-menu-menu',
        expandableElementSelector: '.toggle-menu-menu',
        updateElementSelector: '.navbar',
        toggleClass: 'bg-light-o-50'
    };
    const mobileConfig = {
        clickableElementSelector: '.navbar-toggler',
        expandableElementSelector: '.navbar-toggler',
        updateElementSelector: '.navbar',
        toggleClass: 'bg-light-o-50'
    };

    handleDropdownClick(desktopConfig);
    handleDropdownClick(mobileConfig);
};
